import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingNursery = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Nursery" + level];
    return BF2GetConfigBasedOutskirtBuilding(config, true);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingNursery.ts
// module id = 2167
// module chunks = 3